import AppSettings from '../AppSettings';
// Librairies
import Axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import Cookies from 'universal-cookie';
// Services
import { showToast } from '../utils/ToastsUtil';
// Utils
import DatesUtil from '../utils/DatesUtil';
import { isOnline } from '../utils/offline/Connectivity';

const BACKEND_ENDPOINT = AppSettings.getBackendUrl();

export default class PriceListsService {
    static getCurrencies() {
        return Axios.get(BACKEND_ENDPOINT + 'priceLists/currencies/', {
            headers: { 'Authorization': `Bearer ${new Cookies().get('token')}` }
        }).then(response => {
            return response.data;
        }, () => {
            if (isOnline()) showToast('connection_failed');
            return;
        });
    }

    static getPriceLists() {
        if (!new Cookies().get('token')) return Promise.resolve([]); // Visiteur sans compte : pas de liste personnelle
        return Axios.get(BACKEND_ENDPOINT + 'priceLists/' + jwtDecode(new Cookies().get('token')).id, {
            headers: { 'Authorization': `Bearer ${new Cookies().get('token')}` }
        }).then(response => {
            return response.data;
        }, () => {
            if (isOnline()) showToast('connection_failed');
            return;
        });
    }

    static addPriceList(priceList) {
        return Axios.post(BACKEND_ENDPOINT + 'priceLists/', priceList, {
            headers: { 'Authorization': `Bearer ${new Cookies().get('token')}` }
        }).then(response => {
            if (isOnline()) showToast('price_list_added');
            return response?.data;
        }, () => {
            showToast('price_list_addition_failed');
            return;
        });
    }

    static updatePriceList(priceList) {
        return Axios.put(BACKEND_ENDPOINT + 'priceLists/', priceList, {
            headers: { 'Authorization': `Bearer ${new Cookies().get('token')}` }
        }).then(response => {
            if (isOnline()) showToast('price_list_updated');
            return response?.data;
        }, () => {
            showToast('price_list_update_failed');
            return;
        });
    }

    static deletePriceList(id) {
        return Axios.delete(BACKEND_ENDPOINT + 'priceLists/' + id, {
            headers: { 'Authorization': `Bearer ${new Cookies().get('token')}` }
        }).then(response => {
            showToast('price_list_deleted');
            return response;
        }, () => {
            showToast('price_list_deletion_failed');
            return;
        });
    }

    static exportPriceListAsXLSX(priceList, { exportTrees, exportGreenSpaces, exportFurnitures }) {
        return Axios.post(BACKEND_ENDPOINT + 'priceLists/exportXLSX/', { priceListId: priceList.id, exportTrees, exportGreenSpaces, exportFurnitures }, {
            headers: { 'Authorization': `Bearer ${new Cookies().get('token')}` },
            responseType: 'blob'
        }).then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.ms-excel' }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${priceList.label} - ${DatesUtil.getFormattedLocaleDateString(new Date().toISOString())}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        }, () => {
            showToast('price_list_export_failed');
            return;
        });
    }
}